import { useContext } from 'react'

import { OptionalMiddlewareContext } from '../OptionalMiddleareContext'

export const useOptionalFetchMiddleware = () => {
  return useContext(OptionalMiddlewareContext)
}
